// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__TgYx7","box":"styles_box____EF4","icon":"styles_icon__Hgqhb"};